import React from "react";

interface ModalHeaderProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
}

export const ModalHeader = ({
  icon,
  title,
  subtitle,
}: ModalHeaderProps) => (
  <div className="flex flex-col gap-2 items-center">
    <div className="flex items-center justify-center bg-taupe-4 rounded-full w-[52px] h-[52px]">
      {icon}
    </div>
    <div className="flex flex-col items-center gap-1">
      <h3 className="font-semibold text-2xl leading-[28px] text-light-black">
        {title}
      </h3>
      <p className="text-sm text-center text-light-black leading-5 w-full 2xl:w-96">
        {subtitle}
      </p>
    </div>
  </div>
);
